import { CurrentUser } from '../types/auth';

const SUPER_ADMIN_ROLE = 'Super Admin';

/** The single permission check every part of the app uses — AuthProvider's
 * own `hasPermission` (bound to the live context user) and the post-login
 * redirect validation (Counselor-login-lands-on-/users correction) both
 * call this against a `CurrentUser`, so there's exactly one definition of
 * "does this user have module:action" to ever drift out of sync. */
export const userHasPermission = (user: CurrentUser | null, module: string, action: string): boolean => {
  if (!user) return false;
  if (user.role.name === SUPER_ADMIN_ROLE) return true;
  return user.permissions.some((p) => p.module === module && p.action === action);
};
